"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationMapper = organizationMapper;
exports.organizationMediaMapper = organizationMediaMapper;
exports.mapOrganizationMediaToDocumentMediaPreview = mapOrganizationMediaToDocumentMediaPreview;
const models_1 = require("../models");
const MapperUtils_1 = require("../utils/MapperUtils");
const UserProfileMapper_1 = require("./UserProfileMapper");
const MessageUtil_1 = require("../message/MessageUtil");
function organizationMapper(orgData) {
    const mappedOrgData = orgData.map((org) => {
        var _a;
        return (Object.assign(Object.assign({ organizationId: org.organizationId, organizationName: org.organizationName, organizationNo: org.organizationNo, organizationStatus: models_1.ORGANIZATION_STATUS[org.organizationStatus], unreadAlertCount: org.unreadAlertCount, badgeCount: (_a = org.badgeCount) !== null && _a !== void 0 ? _a : 0, userProfile: (0, UserProfileMapper_1.userProfileMapper)(org.userProfile) }, (org.settings && {
            settings: {
                emrId: org.settings.emrId,
                emrSyncMode: org.settings.emrSyncMode,
                emrSyncInternalGroupIds: org.settings.emrSyncInternalGroupIds,
            },
        })), (org.features && {
            features: {
                enableLabIntegration: org.features.enableLabIntegration,
                enableEmrSync: org.features.enableEmrSync,
                autoAskAcknowledgement: org.features.autoAskAcknowledgement,
            },
        })));
    });
    return (0, MapperUtils_1.sortArrayByKeyValue)(mappedOrgData, "organizationStatus", models_1.ORGANIZATION_STATUS.ACTIVE);
}
function organizationMediaMapper(organizationMediaData) {
    return organizationMediaData.map(media => mapOrganizationMediaToDocumentMediaPreview(media));
}
function mapOrganizationMediaToDocumentMediaPreview(media) {
    const mappedMediaType = models_1.MESSAGE_CONTENT_TYPE[media.type];
    return {
        id: media._id,
        media: [
            {
                url: media.url,
                thumbnail: media.thumbnail,
                mediaType: media.type,
            },
        ],
        mediaType: mappedMediaType,
        title: media.title,
        size: media.size,
        type: mappedMediaType === models_1.MESSAGE_CONTENT_TYPE.DOCUMENT && media.url
            ? (0, MessageUtil_1.attachmentType)(media.url)
            : undefined,
    };
}
